import axios from "axios";

const axiosDefault = axios.create({
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json'
    }
});

axiosDefault.interceptors.request.use((config) => {
    config.baseURL = window.Use?.config?.baseURL ?? "/";
    return config;
});

export default axiosDefault;